import errorCode from '../../utils/errorCode.json';
import COUNTRY_CODE_LIST from './countryCodeList.json';

const json = {
  noPrefix: {},
  errorCode: errorCode.zh_cn,
  countryCodes: COUNTRY_CODE_LIST, // Reference: https://github.com/joonhocho/country-calling-code

  menu: {
    version: '版本',
    homepage: '主頁',
    accountSetting: '帳號設置',
    toggleFilterButtonCollapse: '折疊',
    toggleFilterButtonExpand: '展開',
    toggleBtnCollapse: '折疊',
    toggleBtnExpand: '展開',
    dashboard: '概覽',
    setting: '設置',
    userSetting: '用戶設置',

    transactionRequest: '交易請求',
  },

  common: {
    welcome: '歡迎',
    logout: '登出',
    confirm: '確定',
    edit: '修改',
    cancel: '取消',
    start_date: '開始時間',
    end_date: '結束時間',
    no_data_export: '沒有可導出的數據',
    phSelection: '請選擇{{fieldName}}',
    phInputField: '請輸入{{fieldName}}',
    input_field_check_number: '請輸入有效的{{fieldName}}',
    phSelectionOptional: '請選擇{{fieldName}}(非必填)',
    phInputFieldOptional: '請輸入{{fieldName}}(非必填)',
    search: '查詢',
    reset: '重置',
    export: '導出',
    table: '列表',
    successCreate: '成功生成{{target}}',
    autoLogoutAlert: '因為另一個帳號在同一瀏覽器登錄，此帳號已登出',
    logoutAlert: '您的帳號已登出',
    alert_no_permission: '沒有相關權限',
    programName: '計劃名稱',
    status: '狀態',
    createdBy: '創建人',
    creationDate: '創建日期',
    lastModifiedBy: '最後更新人',
    lastModifiedTime: '最後更新時間',
    lastModifiedDate: '最後更新日期',
    latestVersion: '最新版本',
    applicationNumber: '申請編號',
    txHash: '交易Hash',
    referenceNumber: '參考編號',
    currency: '貨幣',
    approvalProgressDialogTitle: '審批進度',
    no_relevant_permission: '沒有相關權限',
    no_same_operator_creator: '創建人和審批人不能相同',
    no_same_approver: '審批人和操作人不能相同',
    request_approved: '申請已審批',
    approve_successful: '審批成功',
    request_rejected: '申請已拒絕',
    remarks: '備註',
    confirm_btn: '確定',
    approve_btn: '審批',
    reject_btn: '拒絕',
    approve_reject_request_btn: '審批/拒絕',
    viewDetail: '查看明細',
    approve_reject_dialog_title: '審批/拒絕',
    chainName: '鏈名稱',
    selectSearchLabel: '輸入內容以查詢',
    orderId: '訂單編號',
    transactionType: '交易類型',
    amount: '金額',
    sendingAddress: '發送地址',
    receivingAddress: '接收地址',
    creditAmount: '信用金額',
    exchangeRate: '匯率',
    transactionHash: '交易Hash',
    creationTime: '創建時間',
    cancel_btn: '取消',
    approveReject: '審批/拒絕',
    applicationDetails: '申請明細',
    close: '關閉',
    no_data_found: '沒有相關數據',
    auto: '自動',
    create_request: '創建請求',
    hours: '小時',
    minutes: '分鐘',
    seconds: '秒鐘',
    create_request_success: '已成功創建請求',
    create_record_success: '已成功創建記錄',
    copied: '已複製!',
    clientId: '客戶ID',
    create_record: '創建記錄',
    adjustmentAmount: '修改金額',
    createRecord: '創建記錄',
    validate_below_zero: '{{fieldName}}的值需大於0',
    validate_zero: '{{fieldName}}不能等於0',
    no_changes_made_warning: '請修改',
    partnerName: '合作方姓名',
    homeCurrency: '主貨幣',
    adjustmentMode: '調整模式',
    successful_edit: '編輯成功',
    repaymentCurrency: '還款貨幣',
    rewardRate: '回贈率',
    editRecord: '編輯記錄',
    edit_btn: '編輯',
    request_record_created: '已成功創建請求',
    network: '所屬網絡',
    yes: '是',
    no: '否',
    optional_field: '{{fieldName}}(非必填)',
    fromCurrency: '基礎貨幣',
    toCurrency: '相對貨幣',
    agentLoginEmail: '登錄電郵',
    roles: '角色',
    agentName: '名稱',
    noRecord: '沒有相關記錄',
    month: '月份',
    transactionAmount: '交易金額',
    cannot_exceed_warning: '{{fieldName}}不能超過{{value}}',

    from: '從',
    to: '到',

    download: '下載',

    am: '上午',
    pm: '下午',
    programNameDisplay: '計劃名稱（顯示)',
    tokenNotFound: '找不到令牌',
    display_records_limit: '最多顯示{{limit}}條記錄',
    assignedTo: '已分配到',
  },

  enumConstants: {
    en: 'English',
    zh_cn: '繁中',
    timezone0: '+0',
    timezone1: '+1',
    timezone2: '+2',
    timezone3: '+3',
    timezone4: '+4',
    timezone5: '+5',
    timezone6: '+6',
    timezone7: '+7',
    timezone8: '+8',
    timezone9: '+9',
    timezone10: '+10',
    timezone11: '+11',
    timezone12: '+12',
    timezone13: '-11',
    timezone14: '-10',
    timezone15: '-9',
    timezone16: '-8',
    timezone17: '-7',
    timezone18: '-6',
    timezone19: '-5',
    timezone20: '-4',
    timezone21: '-3',
    timezone22: '-2',
    timezone23: '-1',
    Rejected: '已拒絕',
    Pending: '待處理',
    Approved: '已審批',
    Executing: '執行中',
    onHold: '暫時擱置',
    ExecutedSuccess: '執行成功',
    ExecutedFailed: '執行失敗',
    Auto: '自動',
    assigned: '已分派',
    created: '已創建',
    deleted: '已刪除',
    Success: '成功',
    Failed: '失敗',
    Enabled: '已啟動',
    Disabled: '已關閉',
    enable: '已啟動',
    disable: '已關閉',
    Enable: '啟動',
    Disable: '關閉',
    Blacklisted: '已進入黑名單',
    yes: '是',
    no: '否',
    Yes: ',是',
    No: '否',
    Mr: '先生',
    Mrs: '女士',
    Ms: '小姐',
    Male: '男',
    Female: '女',

    // Wallet Transaction Types
    Desposit: '存款',
    Withdraw: '提款',
    Transfer: '轉帳',
    Exchange: '兌換',
    Fee: '手續費',
    Refund: '退款',
    Swap: '交換',
    Payment: '付款',
    FiatWithdraw: '法幣提款',

    // Wallet Status Types (some already exist above, adding missing ones)
    Processing: '處理中',
    Completed: '已完成',
    Cancelled: '已取消',

    // Wallet Direction Types
    In: '流入',
    Out: '流出',

    // Request Types (some may be duplicated below in Wallet Transaction Types)
    CrossMerchantTransfer: '跨商戶轉賬',
    Deposit: '存款',
  },

  userSetting: {
    distributorAgentId: '分銷代理',
    agentType: '代理類型',
    loginEmail: '登錄電郵',
    role: '角色',
    roles: '角色',
    status: '狀態',
    remarks: '備註',
    createdBy: '創建人',
    creationTime: '創建時間',
    lastModifiedBy: '最後更新人',
    lastModifiedTime: '最後更新時間',
    operations: '操作',
    createUser: '創建用戶',
    createUserSuccessAlert: '已成功創建用戶',
    edit: '修改',
    editUser: '修改用戶',
    editUserSuccessAlert: '已成功修改',
    operation: '操作',
    name: '名稱',
  },

  login: {
    email: '電郵',
    password: '密碼',
    send: '發送',
    resend: '重新發送',
    emailNotExistError: '電郵地址不存在',
    programAgentId: '大代理ID',
    enterEmail: {
      email: '電郵地址',
    },
    emailVerification: {
      verificationCode: '驗證碼',
      enterVerificationCode: '請輸入驗證碼',
    },
    resetPassword: {
      successResetAlert: '已成功重置密碼',
      password: '密碼',
      confirmPassword: '確認密碼',
      characterLimit: '8-40數位',
      requiredUpperCase: '至少一個大寫字母',
      requiredSymbol: '至少一個符號',
      requiredNumber: '至少1個數字',
    },
    enterPassword: {
      password: '密碼',
    },
    enterPasswordWithVerify: {
      trustDevice: '信任此裝置',
      verificationCodeCardTitle: '驗證您的設備',
      verificationCodeCardSubtitle: '點擊「發送」，將驗證碼發送到您的電郵地址',
    },
    forgotPassword: '忘記密碼?',
    enterForgotPasswordEmail: {
      title: '忘記密碼?',
      email: '電郵地址',
      enterVerifiedEmail: '請輸入已註冊的電郵地址以接收驗證碼',
      emailNotFound: '電郵地址不存在',
    },
  },

  validation: {
    selectRequired: '請選擇{{fieldName}}',
    inputRequired: '請輸入{{fieldName}}',
    shouldBeLargerThanZero: '{{fieldName}}需大於0',
    requiredLength: '{{fieldName}}需在{{min}}和{{max}}之間',
    requiredUpperCase: '{{fieldName}}必須最少有一個大寫字母',
    requiredSymbol: '密碼必須最少有一個符號',
    requiredContainNumber: '密碼必須最少有一個數字',
    confirmPassword: '密碼和確認密碼必須相同',
    loginEmailInvalid: '電郵地址格式無效',
  },

  component: {
    typeToSearch: '輸入以查詢',
    noRecords: '沒有相關記錄',
    itemTotalStart: '共',
    itemTotalEnd: '條記錄',
    clickSearchToViewRecords: '點擊”查詢”以搜索記錄',
    startMonth: '開始月份',
    endMonth: '結束月份',
  },

  accountSetting: {
    email: '登錄電郵',
    timezone: '時區',
    language: '語言',
    password: '密碼',
    changePassword: '修改密碼',

    creationTime: '創建時間',
    programName: '計劃名稱',
    programDisplayName: '計劃顯示名稱',
    kycIdvMethod: 'IDV方式',
    questionType: '申請表類型',
    programCurrency: '計劃貨幣',
    assignedTo: '已分配到',
    lastModifiedTime: '最後更新時間',
  },
  changePassword: {
    changePassword: '修改密碼',
    confirm: '確定',
    currentPassword: '現有密碼',
    newPassword: '新密碼',
    confirmNewPassword: '確定新密碼',
    confirmPassword: '確定新密碼',
    cancel: '取消',
    changedSuccess: '密碼已更改',
    passwordRequirements: '密碼需包含8-40數位，至少一個大寫字母，一個符號和一個數字',
    characterLimit: '8-40數位',
    requiredUpperCase: '至少一個大寫字母',
    requiredSymbol: '至少一個符號',
    requiredNumber: '至少1個數字',
  },
};

export default json;
